import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import Button from '@rio-cloud/rio-uikit/Button';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { runInBackgroundCallback } from '../../../configuration/setup/backgroundActions';

export const CopyToClipboard = (props: { value: string }) => {
    const intl = useIntl();

    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = runInBackgroundCallback(async (value: string) => {
        try {
            await navigator.clipboard.writeText(value);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (error) {
            console.error('Failed to copy text: ', error);
        }
    });

    const copyButton = (
        <OverlayTrigger
            key={1} // we need different keys to force re-computing the tooltip position
            overlay={<Tooltip>{intl.formatMessage({ id: 'outboundOrderBook.common.copy' })}</Tooltip>}
        >
            <Button
                type="button"
                iconOnly
                iconName="rioglyph-clipboard"
                aria-hidden="true"
                bsStyle={Button.DEFAULT}
                variant={Button.VARIANT_LINK}
                onClick={() => handleCopy(props.value)}
            />
        </OverlayTrigger>
    );

    const isCopiedButton = (
        <OverlayTrigger
            key={2} // we need different keys to force re-computing the tooltip position
            overlay={<Tooltip>{intl.formatMessage({ id: 'outboundOrderBook.common.copied' })}</Tooltip>}
            show // will be auto-hidden by state reset after 2 seconds
        >
            <Button
                type="button"
                iconOnly
                iconName="rioglyph-ok-sign"
                aria-hidden="true"
                bsStyle={Button.SUCCESS}
                variant={Button.VARIANT_LINK}
                onClick={() => handleCopy(props.value)}
            />
        </OverlayTrigger>
    );

    return (
        <>
            {props.value}
            {isCopied ? isCopiedButton : copyButton}
        </>
    );
};
